module.exports = __webpack_public_path__ + "media/images/responsive/logo/logo_suns_black_vertical-2efe290f264bc153312245b3d6517bea.svg";